import '@/assets/css/timeline.css';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { Button, Modal } from 'react-bootstrap';
import { DataAmigavel, DiasEntreDuasDatas, PeriodosAquisitos } from '@/shared/utils/datas';
import { EnumerateDefensores, } from '@/modules/people/defensor.service';
import { EventoTimeline, ReadDefensorResponseDto } from '@/api.types';
import { TipoEventoTimeline } from '../../enums/tipo-evento-timeline.enum';
import { TipoPeriodoDescansoList, TipoLotacaoCompletaList, TipoLotacaoList } from '@/shared/constants/enumlist';
import { readTimeline } from '../../person.service';
import { toast } from 'react-toastify';
import { useReactToPrint } from 'react-to-print';
import { useRef, useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import CalendarioAnual from './CalendarioAnual';

export default function DefensorTimeline() {
  const { setActions } = useBreadcrumbActions();
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const [loaded, setLoaded] = useState(true);
  const [defensorId, setDefensorId] = useState<{
    value: number;
    label: string;
  }>({ value: 0, label: '' });
  const [defensores, setDefensores] = useState<ReadDefensorResponseDto[] | null>(null);

  const [eventosTimeline, setEventosTimeline] = useState<EventoTimeline[]>([]);
  const [visualizacaoCalendario, setVisualizacaoCalendario] = useState(false);
  const [anoCalendario, setAnoCalendario] = useState(new Date().getFullYear());
  const [showModalEventos, setShowModalEventos] = useState(false);
  const [eventosModal, setEventosModal] = useState<EventoTimeline[]>([]);
  const [dataModal, setDataModal] = useState<Date | null>(null);

  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.has('id')) {
      const p = Number(searchParams.get('id'));
      setDefensorId({ value: p, label: '' });
    }
  }, []);

  useEffect(() => {
    EnumerateDefensores(0, 10000)
      .then((result) => {
        setDefensores(result.objects);
        setLoaded(true);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  useEffect(() => {
    if (loaded && defensorId?.value > 0) {
      readTimeline(defensorId.value)
        .then((result) => {
          setEventosTimeline(result);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    }
  }, [defensorId]);

  function EventoHeader(evento: EventoTimeline) {
    return (
      <div className="timeline-dates-body">
        {evento.tipo_evento === TipoEventoTimeline.Acao && (
          <span className="fw-bold">
            {TipoPeriodoDescansoList[Number(evento.tipo)]?.name}{' '}
          </span>
        )}
        {evento.tipo_evento === TipoEventoTimeline.Lotacao && (
          <span className="fw-bold">
            {TipoLotacaoCompletaList[Number(evento.tipo)]?.name}{' '}
          </span>
        )}
        {evento.tipo_evento === TipoEventoTimeline.Substituicao && (
          <span className="fw-bold">Substituindo </span>
        )}
      </div>
    );
  }

  function ContentAcao(evento: EventoTimeline) {
    return (
      evento.tipo_evento === TipoEventoTimeline.Acao && (
        <>
          No período de{' '}
          <span className="fw-bold">{DataAmigavel(evento.inicio)}</span> a{' '}
          <span className="fw-bold">
            {DataAmigavel(evento.termino)}{' '}
            {DiasEntreDuasDatas(evento.inicio, evento.termino)} (dias){' '}
          </span>
          referente a{' '}
          <span className="fw-bold">
            {PeriodosAquisitos(evento.referencia as unknown as Date)}{' '}
          </span>
          {evento.anotacoes && (
            <span className="fw-bold">({evento.anotacoes})</span>
          )}
        </>
      )
    );
  }

  function ContentSubstituicao(evento: EventoTimeline) {
    return (
      evento.tipo_evento === TipoEventoTimeline.Lotacao && (
        <>
          Em <span className="fw-bold">{evento.local} </span>
          {evento.inicio && evento.termino && (
            <>
              no período de{' '}
              <span className="fw-bold">{DataAmigavel(evento.inicio)} </span> a{' '}
              <span className="fw-bold">{DataAmigavel(evento.termino)} </span>
            </>
          )}
          {evento.inicio && !evento.termino && (
            <>
              a partir de{' '}
              <span className="fw-bold">{DataAmigavel(evento.inicio)} </span>
            </>
          )}
          {!evento.inicio && evento.termino && (
            <>
              até{' '}
              <span className="fw-bold">{DataAmigavel(evento.termino)} </span>
            </>
          )}
          {evento.anotacoes && (
            <span className="fw-bold">({evento.anotacoes})</span>
          )}
        </>
      )
    );
  }

  function ContentLotacao(evento: EventoTimeline) {
    return (
      evento.tipo_evento === TipoEventoTimeline.Substituicao && (
        <>
          <span className="fw-bold">{evento.substituindo} </span>
          no período de{' '}
          <span className="fw-bold">{DataAmigavel(evento.inicio)}</span> a{' '}
          <span className="fw-bold">{DataAmigavel(evento.termino)} </span>
          no(a) <span className="fw-bold">{evento.local} </span>
          referente a{' '}
          <span className="fw-bold">
            {TipoPeriodoDescansoList[Number(evento.tipo)].name}{' '}
          </span>{' '}
          de{' '}
          <span className="fw-bold">
            {PeriodosAquisitos(evento.referencia as unknown as Date)}{' '}
          </span>
          {evento.anotacoes && (
            <span className="fw-bold">({evento.anotacoes})</span>
          )}
        </>
      )
    );
  }

  const gerarPDF = useCallback(() => {
    const doc = new jsPDF('landscape');

    const dataAtual = new Date();
    const horarioGeracao = `${dataAtual.toLocaleDateString()} ${dataAtual.toLocaleTimeString()}`;

    const tituloPrincipal = 'Defensoria do Estado de Sergipe';
    const larguraPagina = doc.internal.pageSize.getWidth();
    const alturaTituloPrincipal = 15;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(22);
    doc.setTextColor(0, 102, 45);

    const larguraTextoPrincipal = doc.getTextWidth(tituloPrincipal);
    const posicaoTituloPrincipalX = (larguraPagina - larguraTextoPrincipal) / 2;

    doc.text(tituloPrincipal, posicaoTituloPrincipalX, alturaTituloPrincipal);

    const tituloSecundario = `Histórico do(a) Defensor(a) ${defensorId?.label}`;
    const alturaTituloSecundario = 25;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(15);
    doc.setTextColor(0, 102, 45);

    const larguraTextoSecundario = doc.getTextWidth(tituloSecundario);
    const posicaoTituloSecundarioX =
      (larguraPagina - larguraTextoSecundario) / 2;

    doc.text(
      tituloSecundario,
      posicaoTituloSecundarioX,
      alturaTituloSecundario,
    );

    autoTable(doc, {
      head: [
        [
          'Tipo',
          'Anotações',
          'Início',
          'Fim',
          'Referência',
          'Substituindo',
          'Local',
        ],
      ],
      body: eventosTimeline.map((evento) => {
        return [
          evento.tipo_evento === TipoEventoTimeline.Acao ||
            evento.tipo_evento === TipoEventoTimeline.Substituicao
            ? TipoPeriodoDescansoList[Number(evento.tipo)].name
            : TipoLotacaoList[Number(evento.tipo)].name,
          evento.anotacoes,
          DataAmigavel(evento.inicio),
          DataAmigavel(evento.termino),
          evento.referencia
            ? PeriodosAquisitos(evento.referencia as unknown as Date)
            : '',
          evento.substituindo,
          evento.local,
        ];
      }),
      startY: alturaTituloSecundario + 10,
      styles: { cellPadding: 1, fontSize: 8 },
      theme: 'grid',
    });

    doc.setFontSize(10);
    doc.setTextColor(100);
    const textoRodape = `Gerado em: ${horarioGeracao}`;
    const larguraTexto = doc.getTextWidth(textoRodape);
    const posicaoX = larguraPagina - larguraTexto - 10;

    const alturaRodape = doc.internal.pageSize.getHeight() - 179;
    doc.text(textoRodape, posicaoX, alturaRodape);
    doc.save(`${defensorId?.label}.pdf`);
  }, [defensorId.label, eventosTimeline]);

  useEffect(() => {
    if (defensorId.value <= 0) {
      setActions({});
      return;
    }
    setActions({
      secondary: { label: 'Gerar PDF', onClick: gerarPDF },
      print: { label: 'Imprimir', onClick: () => reactToPrintFn() },
    });
    return () => setActions({});
  }, [defensorId.value, setActions, gerarPDF, reactToPrintFn]);

  return (
    <div ref={contentRef}>
      <div className="row">
        <div className="col-12">
          <h4>Histórico do(a) Defensor(a)</h4>
          <span className="blockquote-footer pb-4 text-end">
            Linha do tempo com as atividades do defensor(a).
          </span>
        </div>
        <hr />
      </div>
      <div className="row mt-3">
        <div className="col-auto">
          <label htmlFor="defensor" className="col-form-label">
            Defensor(a):
          </label>
        </div>
        <div className="col-auto col-md-5">
          <select
            className="form-select"
            title="Defensor"
            id="defensor"
            name="defensor"
            onChange={(e) => {
              const selectedValue = e.target.value;
              if (selectedValue) {
                setDefensorId({
                  value: Number(selectedValue),
                  label: e.target.options[e.target.selectedIndex].text,
                });
              } else {
                setDefensorId({ value: 0, label: '' });
              }
            }}
            value={defensorId.value > 0 ? defensorId.value : ''}
          >
            <option value="" disabled>
              Selecione um(a) defensor(a)
            </option>
            {defensores &&
              defensores.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.pessoa?.nome}
                </option>
              ))}
          </select>
        </div>
        <div className="col-auto">
          <button
            className="btn btn-outline-primary"
            onClick={() => setVisualizacaoCalendario(!visualizacaoCalendario)}
            title={visualizacaoCalendario ? 'Visualizar como Timeline' : 'Visualizar como Calendário'}
          >
            {visualizacaoCalendario ? 'Linha do Tempo' : 'Calendário'}
          </button>
        </div>
      </div>

      {visualizacaoCalendario ? (
        <div className="mt-4">
          <div className="card">
            <div className="card-header text-center">
              <div className="row align-items-center">
                <div className="col-auto">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => setAnoCalendario(anoCalendario - 1)}
                  >
                    ←
                  </Button>
                </div>
                <div className="col">
                  <h5 className="mb-0">
                    Calendário Anual {anoCalendario} - {defensorId?.label || 'Selecione um defensor'}
                  </h5>
                </div>
                <div className="col-auto">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => setAnoCalendario(anoCalendario + 1)}
                  >
                    →
                  </Button>
                </div>
              </div>
            </div>
            <div className="card-body">
              <CalendarioAnual
                ano={anoCalendario}
                eventosTimeline={eventosTimeline}
                onDiaClick={(data, eventos) => {
                  setEventosModal(eventos);
                  setDataModal(data);
                  setShowModalEventos(true);
                }}
              />
            </div>
          </div>

          <Modal show={showModalEventos} onHide={() => setShowModalEventos(false)} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                Eventos em {dataModal ? DataAmigavel(dataModal) : 'Data selecionada'}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {eventosModal.length > 0 ? (
                <div>
                  {eventosModal.map((evento, index) => (
                    <div key={`evento-modal-${evento.id || index}`} className="mb-3 p-3 border rounded">
                      {EventoHeader(evento)}
                      <div className="mt-2">
                        {ContentAcao(evento)}
                        {ContentSubstituicao(evento)}
                        {ContentLotacao(evento)}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center text-muted py-4">
                  Nenhum evento encontrado para esta data.
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModalEventos(false)}>
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      ) : (
        <div className="timeline mt-4 row">
          <div className="col-md-6">
            {eventosTimeline
              .filter((evento) => evento.tipo_evento === TipoEventoTimeline.Acao)
              .map((evento, index) => (
                <div key={`acao-${evento.id || index}`} className="timeline-item-left">
                  {EventoHeader(evento)}
                  <div className="timeline-content">
                    {ContentAcao(evento)}
                    {ContentSubstituicao(evento)}
                    {ContentLotacao(evento)}
                  </div>
                </div>
              ))}
          </div>
          <div className="col-md-6">
            {eventosTimeline
              .filter((evento) => evento.tipo_evento !== TipoEventoTimeline.Acao)
              .map((evento, index) => (
                <div key={`evento-${evento.id || index}`} className="timeline-item-right">
                  {EventoHeader(evento)}
                  <div className="timeline-content">
                    {ContentAcao(evento)}
                    {ContentSubstituicao(evento)}
                    {ContentLotacao(evento)}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
